//*******************************************************
import { Component } from '@angular/core';
//*******************************************************
// Router
import { Router, ActivatedRoute }   from '@angular/router';
//*******************************************************
@Component(
              {
                  selector: 'app-comhome',
                  templateUrl: './comhome.component.html',
                  styleUrls: ['./comhome.component.scss']
              }
          )
//*******************************************************
export class ComhomeComponent 
{
    //*******************************************************
    formheight: number = 0;
    //*******************************************************
    constructor (
                  private _Activatedroute:ActivatedRoute
                ) 
      { 

      }
//*******************************************************
ngOnInit(): void 
  {
  // Form Height
  this.formheight  =  Number(this._Activatedroute.snapshot.paramMap.get("formheight"));
  }
//*******************************************************

}

